<template>
	<div class="app-layout">
		<alert></alert>
		<div class="ui vertical sidebar overlay left menu" v-if="isMobile">
			<merchant-profile></merchant-profile>
			<sidebar :tabs="tabs"></sidebar>
			<sidebar-profile></sidebar-profile>
		</div>

		<div class="pusher">
			<global-announcement></global-announcement>
			<div class="ui top massive icon menu zw-orange top-menu">
				<router-link :to="{name: 'dashboard'}" class="item logo" v-if="!isMobile">
          <img :src="logo" alt="Zietwing">
				</router-link>

				<a class="item" id="sidebarreveal" v-if="isMobile" @click="showSidebar = !showSidebar"><i class="sidebar icon"/></a>
				<language-selector></language-selector>

				<div class="right menu">
					<notification-bell></notification-bell>
					<merchant-menu v-if="activeMerchant" />
				</div>
			</div>

			<div class="zw fullheight">
				<div class="zw lc" v-if="!isMobile">
					<div class="ui vertical sticky zw menu top">
						<merchant-profile />

						<sidebar :tabs="tabs"/>

						<sidebar-profile/>
					</div>
				</div>

				<div class="zw rc">
					<div class="content">
						<semantic-loading :active="activeMerchant === null" :text="$t('globals.loaders.loading')" v-if="activeMerchant === null"></semantic-loading>
						<child v-if="activeMerchant"></child>
					</div>

					<div class="zw bottom right">
						&copy; Zietwing {{ new Date().getFullYear() }}
						<a @click.prevent="showTerms = !showTerms" href="#">{{ $t('modals.termsandconds.normal_header') }}</a>
					</div>
				</div>

				<subscription-modal-container></subscription-modal-container>

				<semantic-modal v-model="showTerms" :settings="{content_classes: {content: true}, closeable: true, closeable_button: true}">
					<div class="ui header" slot="header">
						{{ $t('modals.termsandconds.normal_header') }}
					</div>
					<user-terms></user-terms>
					<div class="actions" slot="actions">
						<div class="ui red deny button">{{ $t('globals.buttons.close') }}</div>
					</div>
				</semantic-modal>
			</div>
		</div>

		<!-- <idlemodal /> -->
	</div>
</template>

<script>
import filter from 'lodash/filter'
import find from 'lodash/find'
import zietwingLogo from '../assets/images/zietwing_logo.svg'

export default {
	name: 'app-layout',

	data () {
		return {
			isMobile: false,
			showSidebar: false,
			tabs: [
				{
					linkto: {name: 'dashboard'},
					title: this.$t('sidebar.menu.dashboard'),
					icon: 'browser'
				},
				{
					linkto: {name: 'archive'},
					title: this.$t('sidebar.menu.archive'),
					icon: 'archive'
				},
				{
					linkto: {name: 'payments'},
					title: this.$t('sidebar.menu.payments'),
					icon: 'payment'
				},
				{
					linkto: {name: 'profile'},
					title: this.$t('sidebar.menu.profile'),
					icon: 'user'
				}
			],
			showTerms: false
		}
	},

	watch: {
		showSidebar: function () {
      let body = document.querySelector('body');

			$(this.$el).find('.ui.sidebar').sidebar({
				delaySetup: true,
				context: '#app .app-layout',
				transition: 'overlay',
        scrollLock: true,
        returnScroll: true,
        onShow: function () {
          body.classList.add('not-scrollable');
        },
        onHidden: function () {
          body.classList.remove('not-scrollable');
        },
			}).sidebar('toggle')
		},
    '$root.$i18n.locale': {
		  immediate: true,
      handler() {
        this.tabs = this.tabs.map(tab => {
          return {
            ...tab,
            title: this.$t('sidebar.menu.' + tab.linkto.name)
          }
        });
      }
    }
	},

	mounted () {
		this.$events.$on('openTerms', () => {
			this.showTerms = !this.showTerms
		})

		if (this.$auth.user()) {
			this.fetchMerchants()
				.then((merchants) => {
          if (merchants) {
            let merchantId = null

            if (this.$store.getters.activeMerchant) {
              merchantId = this.$store.getters.activeMerchant.id
            } else {
              if (merchants.data.length > 0) {
                merchantId = merchants.data[0].id
              }
            }

            if (merchantId) {
              this.fetchActiveMerchant(merchantId)
            } else if (this.$auth.user().external_user) {
              this.fetchMerchantIdForExternalUser(this.$auth.user().id).then((merchantId) => {
                this.fetchActiveMerchant(merchantId)
              }).catch(() => {
                console.log('No merchant found for external user. Log out')
                this.$auth.logout({
                  redirect: 'login',
                  makeRequest: false
                })
              })
            } else {
              console.log('No merchant found. Log out')
              this.$auth.logout({
                redirect: 'login',
                makeRequest: false
              })
            }
          } else {
            console.log('No token. Log out')
            this.$auth.logout({
              redirect: 'login',
              makeRequest: false
            })
          }
				})

			if (process.env.NODE_ENV === 'production') {
				const _this = this

				window.FS.identify(_this.$auth.user().id, {
					displayName: _this.$auth.user().firstname + ' ' + _this.$auth.user().surname,
					email: _this.$auth.user().email
				})
			}
		}

		this.$nextTick(function () {
			window.addEventListener('resize', () => {
				this.checkIfMobile()
			})

			this.checkIfMobile()
		})
	},

	methods: {
		fetchMerchants () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('fetchMerchants').then(() => {
					resolve(this.$store.getters.Merchants)
				}).catch(response => {
					reject(response.data)
				})
			})
		},

    fetchMerchantIdForExternalUser(user_id) {
      return new Promise((resolve, reject) => {
        this.axios.get(`users/${user_id}/merchant`).then(({data}) => {
          resolve(data)
        }).catch(() => {
          reject()
        })
      })
    },

		fetchActiveMerchant (id) {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('fetchMerchant', id).then(() => {
					if (this.$store.getters.activeMerchant && this.$store.getters.activeMerchant.booking) {
						if (!find(this.tabs, {linkto: {name: 'bookings'}})) {
							this.tabs.push(
								{
									linkto: {name: 'bookings'},
									title: this.$t('sidebar.menu.bookings'),
									icon: 'calendar'
								}
							)
						}
					} else {
						this.tabs = filter(this.tabs, currentObject => {
							return currentObject.linkto.name !== 'bookings'
						})

						if (this.$route.name === 'bookings') {
							this.$router.push({name: 'dashboard'})
						}
					}

					if (this.$store.getters.activeMerchant.wait_list) {
						if (!find(this.tabs, {linkto: {name: 'wait_list'}})) {
							this.tabs.push(
								{
									linkto: {name: 'wait_list'},
									title: this.$t('sidebar.menu.wait_list'),
									icon: 'clock outline'
								}
							)
						}
					} else {
						this.tabs = filter(this.tabs, currentObject => {
							return currentObject.linkto.name !== 'wait_list'
						})

						if (this.$route.name === 'wait_list') {
							this.$router.push({name: 'dashboard'})
						}
					}

          if (this.$store.getters.activeMerchant.kamstrup) {
            if (!find(this.tabs, {linkto: {name: 'kamstrup'}})) {
              this.tabs.push(
                {
                  linkto: {name: 'kamstrup'},
                  title: this.$t('sidebar.menu.kamstrup'),
                  icon: 'chart line'
                }
              )
            }

            if (!find(this.tabs, {linkto: {name: 'kamstrup_alarm_settings'}})) {
              this.tabs.push(
                {
                  linkto: {name: 'kamstrup_alarm_settings'},
                  title: this.$t('sidebar.menu.kamstrup_alarm_settings'),
                  icon: 'bell'
                }
              )
            }
          } else {
            this.tabs = filter(this.tabs, currentObject => {
              return currentObject.linkto.name !== 'kamstrup' && currentObject.linkto.name !== 'kamstrup_alarm_settings'
            })

            if (this.$route.name === 'kamstrup' || this.$route.name === 'kamstrup_alarm_settings') {
              this.$router.push({name: 'dashboard'})
            }
          }

					// return active merchant
					resolve(this.$store.getters.activeMerchant)
				}, error => {
					reject(error)
				})
			})
		},

		checkIfMobile () {
			this.isMobile = window.innerWidth <= 1200;
		}
	},

	computed: {
		activeMerchant () {
			return this.$store.getters.activeMerchant
		},

    logo () {
      return zietwingLogo
    }
	}
}
</script>

<style lang="scss">
  .zw-orange {
    .logo {
      padding: 0 !important;
      img {
        width: 130px !important;
        height: 60px;
        padding: 10px;
      }
    }
  }
	.zw {
		&.bottom {
			&.right {
				position: relative;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 20px;
				width: 100%;
				bottom: 0;
				right: 0;
				background: #fff;
			}
		}
	}

  .top-menu {
    margin: 0 !important;

    .logo {
      @media screen and (max-width: 767px){
        max-width: 62px;
      }

      & > .ui.dropdown.item {
        @media screen and (max-width: 767px){
          max-width: 82px;
        }
      }
    }

    .right.menu {
      @media screen and (max-width: 767px){
        max-width: calc(100% - 144px);
        margin-left: auto !important;
        flex-grow: 1;
        justify-content: flex-end;
      }

      .ui.dropdown.item {
        max-width: calc(100% - 60px);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/layouts/app.vue